import { render, staticRenderFns } from "./noodKenE.vue?vue&type=template&id=4e11405f&scoped=true"
import script from "./noodKenE.vue?vue&type=script&lang=js"
export * from "./noodKenE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e11405f",
  null
  
)

export default component.exports